<template>
  <editor :id="id" default-tab="configuration_preset" :tabs="tabs"></editor>
</template>

<script>
import Editor from '@/components/Editor'
import ConfigurationPreset from './editor/ConfigurationPreset'

export default {
  props: ['id'],
  components: {
    Editor
  },
  data () {
    return {
      tabs: [
        {title: "Configuration Preset",      name: "configuration_preset",      component: ConfigurationPreset, admin_only: true},
      ]
    }
  }
}
</script>
